import { AuthService } from '@libs/core/auth-fma';
import { NavController } from '@ionic/angular';

export const logoutInitializer = (authService: AuthService, router: NavController) => async () => {
  authService.logoutCompleted$.subscribe(() => {
    router.navigateRoot('/login');
  });
};
